import Vue from 'vue'
import Router from 'vue-router'
// import { constantRouterMap } from 'vue-router'
import NotFound from '../components/Error/404'
import Login from '../components/Login/Index'
import Home from '../components/Home'
import api from '@/http/api'
import store from '@/store'
import Dashboard from '@/components/Manager/Sys/Dashboard'
import { homeUrl, loginUrl, notFound } from '@/utils/global'

Vue.use(Router)
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }

const router = new Router({
    routes: [
        {
            path: homeUrl,
            // name: '首页',
            component: Home,
            children: [
                {
                    path: '/',
                    name: '仪表盘',
                    component: Dashboard,
                    meta: {
                        icon: 'el-icon-date',
                        index: 0
                    }
                }
            ]
        },
        {
            path: '/',
            redirect: loginUrl
        },
        {
            path: loginUrl,
            name: '登录',
            component: Login
        },
        {
            path: notFound,
            name: '未找到',
            component: NotFound
        },
        {
            path: '/print',
            name: 'print',
            component: resolve =>
                require(['@/components/Manager/Aff/Print.vue'], resolve)
        },
        {
            path: '/printHn',
            name: 'printHn',
            component: resolve =>
                require(['@/components/Manager/Aff/PrintHn.vue'], resolve)
        },
        {
            path: '/printHenan2',
            name: 'printHenan2',
            component: resolve =>
                require(['@/components/Manager/Aff/printHenan2.vue'], resolve)
        },
        {
            path: '/printChongQing',
            name: 'printChongQing',
            component: resolve =>
                require([
                    '@/components/Manager/Aff/printChongQing.vue'
                ], resolve)
        },
        {
            path: '/printMsjxzj',
            name: 'printMsjxzj',
            component: resolve =>
                require(['@/components/Manager/Aff/printMsjxzj.vue'], resolve)
        },
        {
            path: '/printZymy',
            name: 'printZymy',
            component: resolve =>
                require(['@/components/Manager/Aff/printZymy.vue'], resolve)
        },
        {
            path: '/printMsjypt',
            name: 'printMsjypt',
            component: resolve =>
                require(['@/components/Manager/Aff/printMsjypt.vue'], resolve)
        },
        {
            path: '/roomSeat',
            name: 'roomSeat',
            component: resolve =>
                require(['@/components/Manager/Aff/RoomSeat.vue'], resolve)
        },
        {
            path: '/printHeNan',
            name: 'printHeNan',
            component: resolve =>
                require(['@/components/Manager/Aff/printHeNan.vue'], resolve)
        },
        {
            path: '/printMkzn',
            name: 'printMkzn',
            component: resolve =>
                require(['@/components/Manager/Aff/printMkzn.vue'], resolve)
        },
        {
            path: '/scoreAnalyse',
            name: 'print',
            component: resolve =>
                require(['@/components/Manager/App/Scoreanalyse.vue'], resolve)
        },
        {
            path: '/website',
            name: 'website',
            component: resolve =>
                require(['@/components/Manager/App/website.vue'], resolve)
        },
        {
            path: '/ykzyb',
            name: 'ykzyb',
            component: resolve =>
                require(['@/components/Manager/App/ykzyb.vue'], resolve)
        },
        {
            path: '/yklxfw',
            name: 'yklxfw',
            component: resolve =>
                require(['@/components/Manager/App/yklxfw.vue'], resolve)
        },
        {
            path: '/mszytb',
            name: 'mszytb',
            component: resolve =>
                require(['@/components/Manager/App/mszytb.vue'], resolve)
        },
        {
            path: '/ykzyzn',
            name: 'ykzyzn',
            component: resolve =>
                require(['@/components/Manager/App/ykzyzn.vue'], resolve)
        },
        {
            path: '/roomSeatZnz',
            name: 'roomSeatZnz',
            component: resolve =>
                require(['@/components/Manager/Aff/roomSeatZnz.vue'], resolve)
        },
        {
            path: '/printZnz',
            name: 'printZnz',
            component: resolve =>
                require(['@/components/Manager/Aff/printZnz.vue'], resolve)
        },
        {
            path: '/appIndex',
            name: 'appIndex',
            component: resolve =>
                require(['@/components/AppIndex.vue'], resolve)
        },
        {
            path: '/register',
            name: 'register',
            component: resolve =>
                require(['@/components/Register/Index.vue'], resolve)
        }
    ]
})
// eslint-disable-next-line no-unused-vars
var getLastUrl = (str, yourStr) => str.slice(str.lastIndexOf(yourStr) + 1)
router.beforeEach((to, from, next) => {
    // debugger
    if (to.path === notFound) {
        next()
        return
    }

    // App介绍页
    if (to.path === '/appIndex') {
        next()
        return
    }
    // 注册页面
    if (to.path === '/register') {
        next()
        return
    }
    console.log(to.path)
    // getPartners()
    // 登录界面登录成功之后，会把用户信息保存在会话
    // 存在时间为会话生命周期，页面关闭即失效。
    const user = sessionStorage.getItem('user')
    // 如果是访问登录页面，如果用户信息已存在则直接跳转到首页
    if (to.path === loginUrl) {
        if (user) {
            next({ path: homeUrl })
        } else {
            next()
        }
    } else {
        const rous = [
            'print',
            'roomSeat',
            'printHn',
            'printHeNan',
            'website',
            'ykzyb',
            'yklxfw',
            'printMsjxzj',
            'printChongQing',
            'printHenan2',
            'printMkzn',
            'roomSeatZnz',
            'printZnz',
            'mszytb', 'ykzyzn'
        ]
        if (rous.indexOf(to.name) > -1) {
            console.log('to.name', to.name)
            if (to.name === 'yklxfw') {
                document.title = '艺考留学服务中心'
            }
            next()
            return
        }
        if (!user) {
            // 如果访问非登录页面，且用户信息不存在，则跳转到登录页
            next({ path: loginUrl })
        } else {
            // 加载动态菜单和路由
            addDynamicMenuAndRouters(JSON.parse(user), to, from, next)
            next()
        }
    }
    document.title = to.meta.title ? to.meta.title : '轻松艺考'
})

function addDynamicMenuAndRouters(user, to, from, next) {
    // 路由已经加载
    if (store.state.app.menuRouteLoaded) {
        return
    }
    // 请求菜单数据
    api.menu
        .getMenuList({ userId: user.userId })
        .then(res => {
            // 加载动态路由
            const dynamicRoutes = addDynamicRoutes(res.data)
            // console.log(dynamicRoutes)
            // 加入到首页下
            router.options.routes[0].children = router.options.routes[0].children.concat(
                dynamicRoutes
            )
            // 添加路由
            router.addRoutes(router.options.routes)
            // 保存加载状态
            store.commit('menuRouteLoaded', true)
            // 保存菜单树
            store.commit('setNavTree', res.data)
            next()
        })
        .catch(res => {
            console.log('错误：' + res)
        })
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function addDynamicRoutes(menuList = [], routes = []) {
    let temp = []
    for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].children && menuList[i].children.length >= 1) {
            temp = temp.concat(menuList[i].children)
        } else {
            if (!(menuList[i].permUrl && /\S/.test(menuList[i].permUrl))) {
                continue
            }
            const route = {
                path: menuList[i].permUrl,
                component: null,
                // name: menuList[i].description,
                meta: {
                    icon: menuList[i].icon,
                    index: menuList[i].permId,
                    title: menuList[i].description
                }
            }
            const arr = menuList[i].permUrl.split('/')
            let url = ''
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === '') {
                    continue
                }
                url +=
                    arr[i].substring(0, 1).toUpperCase() +
                    arr[i].substring(1) +
                    '/'
            }
            url = url.substring(0, url.length - 1)
            route['component'] = resolve =>
                require([`@/components/Manager/${url}`], resolve)
            routes.push(route)
        }
    }
    if (temp.length >= 1) {
        addDynamicRoutes(temp, routes)
    }
    // TODO: 测试路由，记得删除
    routes.push({
        path: '/aboard/direction',
        meta: {
            icon: 'el-icon-menu',
            title: '方向管理'
        },
        component: resolve =>
            require(['@/components/Manager/Aboard/Direction'], resolve)
    })
    routes.push({
        path: '/wish/remarkEdit',
        meta: {
            icon: 'el-icon-menu',
            title: '备注记录'
        },
        component: resolve =>
            require(['@/components/Manager/Wish/RemarkEdit'], resolve)
    })
    return routes
}

// router.afterEach((to, from) => {
//   // 路由跳转后，根据参数默认选中菜单页面
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js